import { useDispatch } from '@ps/web-core-store';
import { type ActiveGameData } from '@ps/web-poker-types';
import type React from 'react';

import ActiveTableIcon from '../../assets/icons/active-table.svg';
import { StarsButton } from '../buttons';

import styles from './ActiveTableButton.module.scss';

interface Props {
  games?: ActiveGameData[];
}

const ActiveTableButton: React.FC<Props> = ({ games = [] }) => {
  const { modal } = useDispatch();

  const openActiveGamesModal = () =>
    modal.enqueue({
      path: '/poker/active-games',
      locationState: { games }
    });

  return (
    <div className={styles.wrap}>
      <StarsButton
        className={styles.activeTableButton}
        icon={<ActiveTableIcon />}
        type="button"
        onClick={openActiveGamesModal}
      />
      {!!games.length && <span className={styles.badge}>{games.length}</span>}
    </div>
  );
};

ActiveTableButton.defaultProps = {
  games: []
};

export default ActiveTableButton;
